export const convertQuotaToBytes = (quota: string) =>
  Math.round(parseFloat(quota.replace(',', '.')) * 1000 * 1000 * 1000);